import React from "react";
import GalleryWrapper from "./GalleryWrapper";

function GalleryPage() {
  return (
    <>
        <section className="gallery-bg section-bottom-pad"><GalleryWrapper/></section>
    </>
  )
}

export default GalleryPage